:host {
  overflow: hidden;
  width: 0;
  height: 0;
  display: block;
}
